/**
 * Created by Mark on 19/04/2017.
 */


/**
 * Created by Mark on 17/04/2017.
 */

import React  from 'react';
import Layout from '../components/layouts/standard-page.js';
import TeacherForm from '../components/forms/teacher-form.js';
import AssignmentTable from '../components/tables/assignment-table.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHead from '../components/card-header.js';
import Modal from 'react-bootstrap/lib/Modal';
import { FormattedMessage } from 'react-intl';
import { Link , hashHistory } from "react-router";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6
import StaffService from '../services/staff-services.js';
import {Breadcrumb} from "react-bootstrap"
export default class ScoresComponent extends React.Component {

    constructor(props) {
        super();
        this.state = {
            toggleAddUser:false
        };
        this.handelAddUser = this.handelAddUser.bind(this);
        this.handelCreated = this.handelCreated.bind(this);
    }


    handelCreated(){
        StaffService.getAccountsStaff();
        this.setState({toggleAddUser:false});
    }

    handelAddUser(){
        hashHistory.push('/assignment/wizard')
    }


    getBreadCrumb(){

        return  <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={ 'ui-890' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
        </Breadcrumb>
    }

    render(){


        return (<Layout>
            {this.getBreadCrumb()}
                    <Card>
                        <CardHead>
                            <h4><FormattedMessage id={"ui-890" } defaultMessage={ "Assignment History" }/></h4>

                        </CardHead>
                        <CardBody noPadding>
                            <AssignmentTable disableChangeCols additionalButtons = {[{icon:'zmdi zmdi-account-add zmdi-hc-fw' , text: <FormattedMessage id={ 'ui-886' } defaultMessage={ 'New Assignment' }/>, action:this.handelAddUser}]}/>
                        </CardBody>
                        <br />
                    </Card>
                </Layout>);
    }
}




// WEBPACK FOOTER //
// ./src/screens/assignment-management.js